











































import {
  defineComponent,
  onBeforeMount,
  reactive,
  SetupContext,
  watch,
  computed,
} from '@vue/composition-api';
import EntityDialog from '@/components/common/EntityDialog.vue';
import { DropdownFilter } from '@/models/filters/Filters';
import { FontGroup } from '@/models/entities/FontGroup';
import PaginatedAutocomplete from '@/components/utils/PaginatedAutocomplete.vue';
import { Font } from '@/models/entities/Font';

interface Props {
  id: string;
}

interface State {
  entity: FontGroup;
  loading: boolean;
}

const Component = defineComponent({
  name: 'FontGroupDetail',

  components: {
    EntityDialog,
    PaginatedAutocomplete,
  },

  props: {
    id: String,
  },

  setup(props: Props, { root: { $store, $router } }: SetupContext) {
    let fontGroup = new FontGroup({});

    let isNew = () => !props.id;

    onBeforeMount(async () => {
      if (!isNew()) {
        const res = await $store.dispatch(`fontGroupsModule/fetchItem`, props.id);
        if (!res) $router.back();
      }
    });

    const state = reactive({
      entity: fontGroup,
      loading: computed(() => $store.getters['fontGroupsModule/loading']),
    }) as State;

    const fontsFilterDropdown = new DropdownFilter({
      itemsModuleName: 'fontsModule',
      initialValue: state.entity.fonts?.map(({ id }) => id) ?? [],
    });

    watch(
      () => $store.getters['fontGroupsModule/selectedItem'],
      (newValue: FontGroup) => {
        Object.assign(fontGroup, newValue);
        fontsFilterDropdown.initialValue = newValue.fonts?.map(({ id }) => id) ?? [];
      },
      { immediate: false, deep: true },
    );

    const title = computed(() => {
      if (state.loading) return '';
      if (isNew()) return 'New Font Group';
      return `Edit Font Group`;
    });

    const rules = {
      name: [(v: string) => !!v || 'Name is required'],
    };

    function setNewFonts(values: number[]) {
      const newFonts: Font[] = [];
      values.forEach(value => {
        if (typeof value === 'number') {
          const newFont = state.entity.fonts.find(({ id }) => id === value);
          if (newFont) newFonts.push(newFont);
        } else newFonts.push(value);
      });
      state.entity.fonts = newFonts;
      state.entity.totalFonts = newFonts.length;
    }

    return {
      state,
      title,
      rules,
      isNew,
      DropdownFilter,
      setNewFonts,
      fontsFilterDropdown,
    };
  },
});
export default Component;
